import { defineComponent as _defineComponent } from 'vue'
import AppButton from "@/components/AppButton.vue";
import { ImageGroup } from "../data";
import { useCanvases } from "../lib/canvases";
import { useDownload } from "../lib/download";
import { ImageTransform } from "../types";
import ResizeFocalPoint from "./ResizeFocalPoint.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResizeSocial',
  props: {
    groups: null,
    image: null,
    transform: null
  },
  emits: ["update-transform"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update-transform", transform: Partial<ImageTransform>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  groups: ImageGroup[];
  image?: HTMLImageElement;
  transform: ImageTransform;
}





const { downloadAll } = useCanvases();
const { startDownload, downloading } = useDownload();

const updateTransform = (transform: Partial<ImageTransform>): void => {
  emits("update-transform", transform);
};

return { __sfc: true,props, emits, downloadAll, startDownload, downloading, updateTransform, AppButton, ResizeFocalPoint }
}

})